<section class="page-section section-auth section-passwordreset">

    <div class="background-effect"></div>

    <auth-header></auth-header>

    <div class="ui-view-main">

        <div class="container">
            <div class="row">
                <div class="col col-6 col-offset-3">
                    <h2 class="align-center">
                        <span [innerHTML]="'auth.headers.password_reset' | translate"></span>
                    </h2>
                    <p class="intro align-center" [innerHTML]="'auth.text.reset_description' | translate">
                    </p>
                </div>
            </div>

            <ng-container *ngIf="ready else notReady">
                <div class="row">
                    <div class="col col-6 col-offset-3">
                        <form #form (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label for="email" [innerHTML]="'auth.labels.form.email' | translate"></label>
                                <input
                                  class="form-control"
                                  type="email"
                                  name="email"
                                  id="email"
                                  placeholder="{{ 'auth.labels.form.email' | translate }}"
                                  (change)="emailChanged()"
                                  [(ngModel)]="passwordResetInformation.email"
                                >
                                <ng-container *ngFor="let error of errorMessages.email">
                                    <span class="form-validation error" [innerHTML]="error | translate"></span>
                                </ng-container>

                            </div>

                            <div class="form-group">
                                <label for="password" [innerHTML]="'auth.labels.form.password' | translate"></label>
                                <input
                                  class="form-control"
                                  type="password"
                                  name="email"
                                  id="password"
                                  placeholder="{{ 'auth.labels.form.password' | translate }}"
                                  (change)="passwordChanged()"
                                  [(ngModel)]="passwordResetInformation.password"
                                  #password="ngModel">

                                <span class="form-validation" [innerHTML]="'general.form.password.requirements' | translate"></span>

                                <ng-container *ngFor="let error of errorMessages.password">
                                    <span class="form-validation error" [innerHTML]="error | translate"></span>
                                </ng-container>

                            </div>
                            <div class="form-group">
                                <label for="password_confirmation" [innerHTML]="'auth.labels.form.password2' | translate"></label>
                                <input
                                  class="form-control"
                                  type="password"
                                  name="password_confirmation"
                                  id="password_confirmation"
                                  placeholder="{{ 'auth.labels.form.password2' | translate }}"
                                  (change)="passwordChanged()"
                                  [(ngModel)]="passwordResetInformation.passwordConfirmation"
                                  #passwordConfirm="ngModel"
                                >
                            </div>

                            <div class="form-actions form-group">
                                <a routerLink="/"
                                   class="btn-txt"
                                   [innerHTML]="'general.buttons.back' | translate"
                                ></a>
                                <button [disabled]="loading"
                                        class="btn-default small float-right"
                                        type="submit"
                                >
                                    <span [innerHTML]="'auth.buttons.forgot_submit' | translate"></span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </ng-container>

            <ng-template #notReady>
                <loader [show]="true"></loader>
            </ng-template>
        </div>
    </div>
</section>
